export default __webpack_public_path__ + "static/media/15.45d9c999.png";